let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gaPfg")).then(() => parcelRequire('fqR8f'));